import { IBestOffer, IResponseOffer } from "../models/offer";
import { Constants } from "../common/constants";
import { IAuction } from "../models/auction";
import { IProfile } from "../models/profile";
import { useNavigate } from "react-router-dom";

export const makeOffer = async (offer: IBestOffer, price: number) : Promise<IResponseOffer> => {
  const account: IProfile = JSON.parse(localStorage.getItem("account") || "{}");
  const token = JSON.parse(localStorage.getItem("token") || "");
  console.log(offer);
  console.log(account);
  console.log(token);

  const headers = { 'Authorization': `Bearer ${token}` };
  const payload = { 
    OfferID:-1, 
    AuctionID: offer.AuctionID, 
    Price: price, 
    UserID: account.userid, 
    UserName: account.displayname,
    Status:0,
    InsDateTime: new Date(),
    InsUserID:0,
    UpdDateTime: new Date(),
    UpdUserID:0
  }

  const requestOptions = {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json', 
      'Authorization': `Bearer ${token}`,
      'Access-Control-Allow-Origin': `${Constants.weburl}` 
    },
    body: JSON.stringify(payload)
  };

  const res: Response = await fetch(`${Constants.apiurl}/api/utilities/InsertOffer`, requestOptions);
  console.log(res);
  if(res.ok){
    const res1 = await res.json();
    return res1;
  } else {
    if(res.status === 401) {
      return { Success: false, Message: '401', Result: {} };
    }
    const res2 = await res.json();
    return res2;
  }
}

export const getBestOffers = async () : Promise<IBestOffer[]> => {
  let result: IBestOffer[] = [];
  const res: Response = await fetch(`${Constants.apiurl}/api/utilities/getbestoffers`);
  //console.log(res);
  if(!res.ok) {
      //throw new Error('Network response was not ok');
      console.log(res);
  } else {
      const res1 = await res.json();
      console.log(res1);
      //result = res1;
      return res1;
  }
  console.log(result);
  return result;
}

export const getOffersByUser = async () : Promise<any[]> => {
  const token = getToken();
  const requestOptions = {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json', 
      'Authorization': `Bearer ${token}`,
      'Access-Control-Allow-Origin': `${Constants.weburl}` 
    }
  };

  const res: Response = await fetch(`${Constants.apiurl}/api/utilities/getoffersbyuser`, requestOptions);
  console.log(res);
  const res1 = await res.json();
  console.log(res1);
  return res1;
}

export const getOffersByAuction = async (auctionID: string) : Promise<any[]> => {
  const token = getToken();
  const requestOptions = {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json', 
      'Authorization': `Bearer ${token}`,
      'Access-Control-Allow-Origin': `${Constants.weburl}` 
    }
  };

  const res: Response = await fetch(`${Constants.apiurl}/api/utilities/getoffersbyauction?auctionID=${auctionID}`, requestOptions);
  console.log(res);
  const res1 = await res.json();
  console.log(res1);
  return res1;
}

// export const getRoles = async (instance: IPublicClientApplication) : Promise<any> => {
//   const account = instance.getAllAccounts()[0];
//   console.log(account);
//   console.log(instance);
//   const accessTokenRequest = {
//       scopes: Constants.scopes,
//       account: account,
//   };  
//   await instance.initialize();
//   const token = await instance.acquireTokenSilent(accessTokenRequest);
//   console.log(token);

//   const requestOptions = {
//     method: 'GET',
//     headers: { 
//       'Content-Type': 'application/json', 
//       'Authorization': `Bearer ${token.accessToken}`,
//       'Access-Control-Allow-Origin': `${Constants.weburl}` 
//     },
//   };
//   let result: IBestOffer[] = [];
//   const res: Response = await fetch(`${Constants.apiurl}/api/utilities/getroles`, requestOptions);
//   //console.log(res);
//   if(!res.ok) {
//       //throw new Error('Network response was not ok');
//       console.log(res);
//   } else {
//       const res1 = await res.json();
//       console.log(res1);
//       //result = res1;
//       return res1;
//   }
//   console.log(result);
//   return result;
// }

export const getAuctions = async () : Promise<any[]> => {
  const token = getToken();
  const requestOptions = {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json', 
      'Authorization': `Bearer ${token}`,
      'Access-Control-Allow-Origin': `${Constants.weburl}` 
    }
  };

  const res: Response = await fetch(`${Constants.apiurl}/odata/auctions`, requestOptions);
  console.log(res);
  if(!res.ok) {
      console.log(res);
      return [];
  } else {
      const res1 = await res.json();
      console.log(res1.value);
      return res1.value;
  }
}

export const saveAuction = async (auction: IAuction) : Promise<IAuction|undefined> => {
  const token = getToken();
  let payload = {
    JerseyNumber: auction.JerseyNumber, 
    Team: auction.Team,
    Fullname: auction.Fullname,    
  };
  let url = `${Constants.apiurl}/odata/auctions`;
  let method = "POST";

  if(auction.ID === '-1'){
    payload = Object.assign(payload, { 
      Status:0,
      InsDateTime: new Date(),
      InsUserID:0,
      UpdDateTime: new Date(),
      UpdUserID:0
    });
  } else {
    payload = Object.assign(payload, { 
      UpdDateTime: new Date(),
    });
    url = `${Constants.apiurl}/odata/auctions/${auction.ID}`;
    method = "PATCH";
  }

  const requestOptions = {
    method: method,
    headers: { 
      'Content-Type': 'application/json', 
      'Authorization': `Bearer ${token}`,
      'Access-Control-Allow-Origin': `${Constants.weburl}` 
    },
    body: JSON.stringify(payload)
  };  

  const res: Response = await fetch(url, requestOptions);
  console.log(res);
  if(!res.ok) {
      console.log(res);
      return undefined;
  } else {
      const res1 = await res.json();
      console.log(res1);
      return res1;
  }
}

export const deleteAuction = async (auction: IAuction) : Promise<boolean> => {
  const token = getToken();
  let url = `${Constants.apiurl}/odata/auctions/${auction.ID}`;
  let method = "DELETE";

  const requestOptions = {
    method: method,
    headers: { 
      'Content-Type': 'application/json', 
      'Authorization': `Bearer ${token}`,
      'Access-Control-Allow-Origin': `${Constants.weburl}` 
    },
  };  

  const res: Response = await fetch(url, requestOptions);
  console.log(res);
  return res.ok;
}

export const getUsers = async () : Promise<any[]> => {
  const token = getToken();
  const requestOptions = {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json', 
      'Authorization': `Bearer ${token}`,
      'Access-Control-Allow-Origin': `${Constants.weburl}` 
    }
  };

  const res: Response = await fetch(`${Constants.apiurl}/api/utilities/getusers`, requestOptions);
  console.log(res);
  if(!res.ok) {
      console.log(res);
      return [];
  } else {
      const res1 = await res.json();
      console.log(res1);
      return res1;
  }
}

export const saveUser = async (user: IProfile) : Promise<void> => {
  const token = getToken();
  // let payload = {
  //   JerseyNumber: auction.JerseyNumber, 
  //   Team: auction.Team,
  //   Fullname: auction.Fullname,    
  // };
  // let url = `${Constants.apiurl}/odata/auctions`;
  // let method = "POST";

  // if(auction.ID === '-1'){
  //   payload = Object.assign(payload, { 
  //     Status:0,
  //     InsDateTime: new Date(),
  //     InsUserID:0,
  //     UpdDateTime: new Date(),
  //     UpdUserID:0
  //   });
  // } else {
  //   payload = Object.assign(payload, { 
  //     UpdDateTime: new Date(),
  //   });
  //   url = `${Constants.apiurl}/odata/auctions/${auction.ID}`;
  //   method = "PATCH";
  // }

  // const requestOptions = {
  //   method: method,
  //   headers: { 
  //     'Content-Type': 'application/json', 
  //     'Authorization': `Bearer ${token}`,
  //     'Access-Control-Allow-Origin': `${Constants.weburl}` 
  //   },
  //   body: JSON.stringify(payload)
  // };  

  // const res: Response = await fetch(url, requestOptions);
  // console.log(res);
  // if(!res.ok) {
  //     console.log(res);
  //     return undefined;
  // } else {
  //     const res1 = await res.json();
  //     console.log(res1);
  //     return res1;
  // }
}

const getToken = () : string => {
  const token = JSON.parse(localStorage.getItem("token") || "");
  return token;
}

export const login = async (user: string, password: string) : Promise<any> => {
  const requestOptions = {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json', 
      'Access-Control-Allow-Origin': `${Constants.weburl}` 
    },
    body: JSON.stringify({
      username: user,
      password: password,
      clientid: 'auction'
    })
  };
  const res: Response = await fetch(`${Constants.apiurl}/token`, requestOptions);
  if(res.ok) {
    console.log(res);
    const a = await res.json();
    console.log(a);
    return a; 
  } else {
    return { Success: false, Message: 'Errore di autenticazione' };
  }
}

export const register = async (data: any) : Promise<any> => {
  const user = {
    username: data.username,
    password: data.password,
    displayname: data.displayname,
    firstname: data.nome,
    lastname: data.cognome,
    clientid: 'auction'
  };

  const requestOptions = {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json', 
      'Access-Control-Allow-Origin': `${Constants.weburl}` 
    },
    body: JSON.stringify(user)
  };

  const res: Response = await fetch(`${Constants.apiurl}/register`, requestOptions);
  console.log(res);
  const a = await res.json();
  console.log(a);
  return a; 
}

export const activate = async (data: string) : Promise<any> => {
 const requestOptions = {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json', 
      'Access-Control-Allow-Origin': `${Constants.weburl}` 
    },
    body: JSON.stringify({
      username: data,
      password: '',
      clientid: 'auction'
    })
  };

  const res: Response = await fetch(`${Constants.apiurl}/activate`, requestOptions);
  console.log(res);
  const a = await res.json();
  console.log(a);
  return a; 
}
